module.exports = __webpack_public_path__ + "img/icon-event-folder.d445b476.svg";